import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function noFutureDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const today = new Date();
    const inputDate = new Date(Date.parse(control.value));
    return inputDate > today ? { noFutureDates: true } : null;
  };
}
